<template>
  <div id="app">

        <Navbar/>

        <!-- Subtitle Recepción -->
        <Subtitle id="recepcion" :title="'Recepción'"/>
        <div class="square-container">
            <ImagesSquare
                :colors="{ main: '63,132,248', second: '4,88,191' }"
                :details="{
                    hour:       '6:00pm',
                    date:       'Sábado 16 nov',
                    imgFolder:  { name: 'hotel', count: 4 },
                    link:       { name: 'Nuevo Vallarta, Nayarit', link:'https://goo.gl/maps/J2Jeq7n91b6p9zfs8' },
                    place:      { name: 'Hotel Villa Varadero', icon: 'building' },
                }"
            />
        </div>

        <!-- Subtitle Ceremonia Religiosa -->
        <Subtitle id="ceremonia" :title="'Ceremonia Religiosa'"/>
        <div class="square-container">
            <ImagesSquare
                :colors="{ main: '229,129,153', second: '96,73,115' }"
                :details="{
                    hour:       '4:30pm',
                    date:       'Sábado 16 nov',
                    imgFolder:  { name: 'misa', count: 4 },
                    link:       { name: 'Jarretaderas, Nayarit', link:'https://goo.gl/maps/jvN2eS8bTEi3HCWP9' },
                    place:      { name: 'Parroquía La Sagrada Familia', icon: 'place-of-worship' },
                }"
            />
        </div>

        <!-- Subtitle Agenda -->
        <Subtitle id="agenda" :title="'Agenda'"/> 
        <Agenda/>

        <!-- Subtitle Sesión de fotos -->
        <Subtitle id="fotos" :title="'Sesiones de fotos'"/>
        <div class="square-container-double">
            <ImagesSquare
                :options="'smaller'"
                :colors="{ main: '229,129,153', second: '96,73,115' }"
                :details="{
                    imgFolder:  { name: 'sesionFotos/vallarta', count: 27 },
                    link:       { name: 'Eduardo Rivera', link:'https://www.facebook.com/EduardoRiveraFotografia', icon: 'camera' },
                    place:      { name: 'Playa Conchas Chinas, Puerto Vallarta', icon: 'umbrella-beach' },
                }"
            />
            <ImagesSquare
                :options="'smaller'"
                :colors="{ main: '229,129,153', second: '96,73,115' }"
                :details="{
                    imgFolder:  { name: 'sesionFotos/monterrey', count: 24 },
                    link:       { name: 'Evelyn Sanchez', link:'https://www.facebook.com/evephography99', icon: 'camera' },
                    place:      { name: 'La Huasteca, Monterrey', icon: 'mountain' },
                }"
            />
        </div>

        <!-- Subtitle Preguntas frecuentes -->
        <Subtitle id="preguntas" :title="'Preguntas frecuentes'"/>
        <FAQ/>

        <!-- Subtitle Regalos -->
        <Subtitle id="regalos" :title="'Regalos'"/>
        <div class="text-container">
            <div class="text-size">
                <p class="gifts-text">
                    <strong> El mejor regalo que pudieras hacernos, es que asistieras a nuestra boda. </strong>
                    Apreciamos mucho los regalos materiales, pero apreciamos más que compartas un poco de tu tiempo con nosotros
                    en este día tan especial.
                </p>
                <div style="text-align: right">
                    <button v-if="!showGifts" @click="showGifts = true" class="extra-gift-btn">
                        No importa, quiero obsequiarles algo más
                    </button>
                </div>

                <span v-if="showGifts">
                    <p class="gifts-text">
                        Si aún así, quieres regalarnos algo más, puedes obsequiarnos lo que quieras, lo dejamos a tu imaginación;
                        o bien, puedes seleccionar algo de nuestra mesa de regalos.
                    </p>
                    <hr>
                    <Gift/>
                </span>
            </div>
        </div>

        <div class="footer">
            <p>
                Página realizada por el novio
                <a href="https://www.facebook.com/adr.rosales" target="_blank"> 🤵🏻 </a>
            </p>
        </div>
        
  </div>
</template>

<script>
import Vue from 'vue'
import ImagesSquare from './components/ImagesSquare.vue'
import Subtitle from './components/Subtitle.vue'
import Navbar from './components/Navbar.vue'
import Agenda from './components/Agenda.vue'
import Gift from './components/Gift.vue'
import FAQ from './components/FAQ.vue'

export default {
  
  name: 'app',
  
  components: {
    Agenda, FAQ, ImagesSquare, Navbar, Subtitle, Gift
  },

  data() {
      return {
          showGifts: false
      }
  }
  
}
</script>

<style lang="scss">
@import "./components/variables.scss";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.extra-gift-btn {
    opacity: .5;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px 9px;
    border-radius: 10px;
    background: cornflowerblue;
    &:hover {
        opacity: 1;
    }
}

.footer {
    height: 60px;
    color: white;
    padding-top: 1px;
    margin-top: 40px;
    background: #333;
}

.gifts-text {
    font-size: 19px;
    @media screen and (max-width: $break-sm) {
        font-size: 15px;
    }
}

.square-container{
    display: flex;
    justify-content: center;
    margin: 0 50px;
    @media screen and (max-width: $break-lg) {
        flex-direction: column;
        text-align: -webkit-center;
    }
    @media screen and (max-width: $break-sm) {
        margin: 0;
    }
}

.square-container-double {
    display: flex;
    justify-content: center;
    margin: 0 250px;
    @media screen and (max-width: $break-lg) {
        margin: 0 50px;
        flex-direction: column;
        text-align: -webkit-center;
    }
    @media screen and (max-width: $break-sm) {
        margin: 0;
    }
}


.text-container {
    display: flex;
    margin: 0 10px 0 10px;
    justify-content: center;
}

.text-size {
    width: 50%;
    text-align: justify;
    @media screen and (max-width: $break-lg) {
        width: 70%;
    }
    @media screen and (max-width: $break-md) {
        width: 90%;
    }
}

</style>
